module.exports = __webpack_public_path__ + "img/2.bcff93b7.png";